import { Component,ElementRef, Renderer2, HostListener,ViewChild} from '@angular/core';
import SwiperCore,{Autoplay,Keyboard,Pagination,Navigation} from 'swiper';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { Router, RouterModule } from '@angular/router';




SwiperCore.use([Autoplay,Pagination,Keyboard,Navigation])

@Component({
  selector: 'app-ads',
  templateUrl: './ads.component.html',
  styleUrls: ['./ads.component.scss']
})
export class AdsComponent {
  
  constructor(private router: Router,private el: ElementRef, private renderer: Renderer2){

  }

  ngOnInit(): void {
   
}




  


  scrollTOView9(){

    window.scrollTo(0, 1090);
    
  }


  onClick9(){
    
    let hom=window.location.href
    console.log(hom)
    
    if(hom.search('home')!=-1)
    
    window.scrollTo(0, 1090);
    
    else{
    
    // this.router.navigate(['/landing/contacts']);
    this.scrollTOView9();


    // setTimeout(()=>{
    
    // this.scrollTOView9();
    
    // },800)
    
    } 
  }

  scrollTOView11(){

    window.scrollTo(0, 850);
    
  }
  
  
  onClick11(){
    
    let hom=window.location.href
    console.log(hom)
    
    if(hom.search('home')!=-1)
    
    window.scrollTo(0, 850);
    
    else{
    
    this.router.navigate(['/contacts']);
    

    setTimeout(()=>{
    
    this.scrollTOView11();
    
    },800)
    
    } 
  }



  myFunction() {
    var dots = document.getElementById("dots");
    var moreText = document.getElementById("more");
    var btnText = document.getElementById("myBtn");
  
    if (dots!.style.display === "none") {
      dots!.style.display = "inline";
      btnText!.innerHTML = "Read More";
      moreText!.style.display = "none";
  
    } else {
      dots!.style.display = "none";
      btnText!.innerHTML = "Read Less";
      moreText!.style.display = "inline";
    }
  }
 
  

    

  

}
